// src/pages/LeadsEdit.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import TabProfile from "../customersCreate/TabProfile";
import "./LeadsEdit.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API = `${process.env.REACT_APP_API_BASE_URL}`;

const LeadsEdit = () => {
  const { id: adminId } = useParams();
  const navigate = useNavigate();

  const [adminData, setAdminData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    role_id: "",
    language: "",
    adminImage: "",
    warehouse_id: "",
  });

  const [rolesOptions, setRolesOptions] = useState([]);
  const [languagesOptions, setLanguagesOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [avatarList, setAvatarList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [warehousesOptions, setWarehousesOptions] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  // Helper: göreceli yoldan tam URL üretir
  const toFullUrl = (p) => (p.startsWith("http") ? p : `${API}${p}`);

  useEffect(() => {
    if (!adminId) return;

    const init = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("admin_token");
        const auth = { headers: { Authorization: `Bearer ${token}` } };

        const adminRes = await axios.get(`${API}/api/admin/${adminId}`, auth);
        const admin = {
          ...adminRes.data,
          adminImage:
            adminRes.data.adminImage && adminRes.data.adminImage.trim() !== ""
              ? adminRes.data.adminImage
              : "/uploads/avatars/default.svg",
        };
        setAdminData(admin);

        const rolesRes = await axios.get(`${API}/api/roles`, auth);
        const myRole = localStorage.getItem("userRole");

        const roles = rolesRes.data
          .filter((r) => {
            // aktif rol
            if (r.status !== 1) return false;

            // superadmin değilsem VE
            // düzenlenen kullanıcı superadmin DEĞİLSE
            // → superadmin rolünü gösterme
            if (
              myRole !== "superadmin" &&
              r.role_name === "superadmin" &&
              admin.role_id !== r.id
            ) {
              return false;
            }

            return true;
          })
          .map((r) => ({
            label: r.role_name,
            value: r.id.toString(),
          }));

        setRolesOptions(roles);

        const foundRole =
          roles.find((r) => r.value === admin.role_id.toString()) || null;
        setSelectedRole(foundRole);

        const langsRes = await axios.get(`${API}/api/languages/list/active`);
        const langs = langsRes.data.map((l) => ({
          label: l.name,
          value: l.code,
        }));
        setLanguagesOptions(langs);

        const foundLang = langs.find((l) => l.value === admin.language) || null;
        setSelectedLanguage(foundLang);

        const whRes = await axios.get(`${API}/api/warehouses`, auth);
        const whOptions = whRes.data.map((w) => ({
          label: w.title || w.name,
          value: w.id.toString(),
        }));
        setWarehousesOptions(whOptions);

        setSelectedWarehouse(
          whOptions.find(
            (w) => Number(w.value) === Number(admin.warehouse_id),
          ) || null,
        );

        // Buraya debug ekleyelim:
        console.log("Gelen admin verisi:", admin);
        console.log("Tüm roller:", roles);
        console.log("Bulunan rol:", foundRole);
        console.log("Tüm diller:", langs);
        console.log("Bulunan dil:", foundLang);

        const avatarsRes = await axios.get(`${API}/api/avatars`);
        setAvatarList(avatarsRes.data.map((p) => `${API}${p}`));
      } catch (err) {
        console.error("❌ Veri yükleme hatası:", err);
        toast.error("Veriler yüklenirken hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [adminId]);
  // Depo seçenekleri geldikten ve adminData yüklendikten sonra depo eşle
  useEffect(() => {
    if (!adminData) return;
    if (!warehousesOptions.length) return;

    const match = warehousesOptions.find(
      (w) => Number(w.value) === Number(adminData.warehouse_id),
    );

    setSelectedWarehouse(match || null);
  }, [adminData.warehouse_id, warehousesOptions]);

  const handleChange = (e) =>
    setAdminData({ ...adminData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const cleanPhone = adminData.phone.replace(/\D/g, "");
      const token = localStorage.getItem("admin_token");
      await axios.put(
        `${API}/api/admin/${adminId}/update`,
        {
          ...adminData,
          role_id: selectedRole?.value,
          phone: cleanPhone,
          language: selectedLanguage?.value,
          warehouse_id: selectedWarehouse?.value
            ? Number(selectedWarehouse.value)
            : null,
          adminImage: adminData.adminImage,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const dataToSend = {
        ...adminData,
        role_id: selectedRole?.value,
        language: selectedLanguage?.value,
        warehouse_id: selectedWarehouse?.value
          ? Number(selectedWarehouse.value)
          : null,
        adminImage: adminData.adminImage,
      };
      console.log("📤 Gönderilecek veri:", dataToSend);
      console.log("📦 Warehouse ID:", dataToSend.warehouse_id);
      console.log("Gönderilen:", {
        ...adminData,
        role_id: Number(selectedRole?.value),
        language: selectedLanguage?.value,
        warehouse_id: Number(selectedWarehouse?.value),
      });

      toast.success("Admin bilgileri başarıyla güncellendi!");
      navigate("/leads/list");
    } catch (err) {
      console.error("Güncelleme hatası:", err);
      toast.error("Güncelleme başarısız!");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      <div className="container">
        <div className="card border-top-0">
          {loading ? (
            <div className="p-4 text-center">Yükleniyor…</div>
          ) : (
            <div className="tab-content">
              <TabProfile
                adminData={adminData}
                handleInputChange={handleChange}
                handleAvatarSelect={(relPath) =>
                  setAdminData({ ...adminData, adminImage: relPath })
                }
                avatarList={avatarList}
                handleSubmit={handleSubmit}
                rolesOptions={rolesOptions}
                selectedRole={selectedRole}
                setSelectedRole={setSelectedRole}
                languagesOptions={languagesOptions}
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
                warehouseOptions={warehousesOptions}
                selectedWarehouse={selectedWarehouse}
                setSelectedWarehouse={setSelectedWarehouse}
                setAdminData={setAdminData}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadsEdit;
